angular.module('bmsApp.settings').factory('OnlineSlotsSvc', function ($http, $log, $window, $q, CRUDSvc) {

	return {
		index: function (params) {
			return CRUDSvc.get('api/settings/online-slots/index', params);
		},
		save: function (params) {
			return CRUDSvc.post('api/settings/online-slots/save', params);
		}
	}

});

